import React from "react";
import styled from "@emotion/styled";
import SeminarCard from "components/SeminarCard";
import Slider from "react-slick";
import { Link } from "gatsby";

const SeminarSliderLayout = styled.div`
  img {
    height: 350px;
    object-fit: cover;
  }

  display: flex;
  margin-top: 128px;
  margin-bottom: 128px;
  background: ${props => props.color};
  transition: 0.1s;
  margin-left: 16px;
  margin-right: 16px;

  @media screen and (max-width: 640px) {
    margin-top: 64px;
    margin-bottom: 32px;
    margin-left: ${props => (props.geser ? "calc(-100% - 96px)" : "-32px")};
    margin-right: ${props => (props.geser ? "-32px" : "calc(-100% - 96px)")};
  }

  @media screen and (max-width: 600px) {
    margin-top: 64px;
    margin-bottom: 32px;
    margin-left: ${props => (props.geser ? "calc(-100% - 48px)" : "-16px")};
    margin-right: ${props => (props.geser ? "-16px" : "calc(-100% - 48px)")};
  }

  .slick-next,
  .slick-prev {
    top: auto;
    bottom: -64px;

    &:before {
      display: none;
    }
  }

  .slick-next {
    right: 16px;

    @media screen and (max-width: 320px) {
      right: auto;
      left: 75vw;
    }
  }

  .slick-prev {
    left: auto;
    right: 64px;

    @media screen and (max-width: 320px) {
      right: auto;
      left: calc(75vw - 48px);
    }
  }
`;

const Description = styled.div`
  width: 40%;
  padding: 16px 32px;
  box-sizing: border-box;

  @media screen and (max-width: 800px) {
    width: 50%;
  }

  @media screen and (max-width: 640px) {
    padding: 16px;
  }

  h3 {
    font-family: ${props => props.theme.fonts.subheading};
    margin: 8px 0;
    text-transform: capitalize;
    text-align: left;

    @media screen and (max-width: 640px) {
      width: 100%;
    }
  }

  ul {
    list-style: none;
    margin: 16px 0;
    padding: 0;
    text-align: left;
    font-size: 20px;

    @media screen and (max-width: 640px) {
      font-size: 16px;
    }

    li {
      padding: 4px 0;
      display: flex;
      align-items: center;

      span {
        text-align: center;
        width: 32px;
        display: inline-block;
      }
    }
  }
`;

const MainButton = styled.div`
  text-align: left;

  button {
    padding: 8px 16px;
    border: none;
    cursor: pointer;

    &.detail {
      background: none;
      color: #fff;
    }

    &.daftar {
      background: #fff;
      color: #000;
      border-radius: 20px;
    }
  }
`;

const SpeakerButton = styled.div`
  display: none;
  cursor: pointer;
  margin-top: 16px;
  text-align: right;

  @media screen and (max-width: 640px) {
    display: block;
  }
`;

const SliderGroup = styled.div`
  width: 60%;
  padding: 0 16px 64px;
  box-sizing: border-box;

  @media screen and (max-width: 800px) {
    width: 50%;
  }

  @media screen and (max-width: 640px) {
    position: relative;
  }
`;

const BackButton = styled.div`
  position: absolute;
  font-size: 16px;
  cursor: pointer;
  display: none;
  left: 32px;
  bottom: 24px;

  @media screen and (max-width: 640px) {
    display: block;
  }
`;

const SliderWrapper = styled.div`
  margin-top: -48px;

  @media screen and (max-width: 640px) {
    margin-top: -32px;
  }

  @media screen and (max-width: 320px) {
    margin-top: -20px;
  }
`;

const ArrowStyle = styled.div`
  background: white;
  padding: 8px;
  text-align: center;
  border-radius: 50%;

  &:hover {
    background: white;
  }

  &.slick-disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const sliderSettings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: <Arrow />,
  nextArrow: <Arrow reverse />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

export default function SeminarCarousel({ data }) {
  const [geser, setGeser] = React.useState(false);

  return (
    <SeminarSliderLayout color={data.color} geser={geser}>
      <Description>
        <h3>{data.title}</h3>
        <ul>
          <li>
            <span>
              <PlaceIcon />
            </span>
            {data.place}
          </li>
          <li>
            <span>
              <DateIcon />
            </span>
            {data.date}
          </li>
          {data.price && (
            <li>
              <span>
                <PriceIcon />
              </span>
              {data.price}
            </li>
          )}
        </ul>
        <MainButton>
          <Link to={data.detail}>
            <button className="detail">DETAIL</button>
          </Link>
          <Link to={data.daftar}>
            <button className="daftar">DAFTAR</button>
          </Link>
        </MainButton>
        <SpeakerButton onClick={() => setGeser(true)}>
          SPEAKER{" "}
          <Arrow
            reverse
            style={{ width: "20px", height: "20px", display: "inline-block" }}
          />
        </SpeakerButton>
      </Description>
      <SliderGroup>
        <SliderWrapper>
          <Slider {...sliderSettings}>
            {data.speakers.map(speaker => (
              <SeminarCard {...speaker} key={speaker.name} />
            ))}
          </Slider>
        </SliderWrapper>
        <BackButton onClick={() => setGeser(false)}>Back</BackButton>
      </SliderGroup>
    </SeminarSliderLayout>
  );
}

function Arrow(props) {
  return (
    <ArrowStyle {...props}>
      <svg
        width="13"
        height="17"
        viewBox="0 0 13 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d={
            props.reverse
              ? "M0.999999 16L12 8.14286L1 1"
              : "M12 16L0.999999 8.14286L12 1"
          }
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </ArrowStyle>
  );
}

const PlaceIcon = () => (
  <svg
    width="13"
    height="18"
    viewBox="0 0 13 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.36635 0.31543C3.34948 0.31543 0.617188 2.76098 0.617188 5.77858C0.617188 8.79545 3.11017 12.3973 6.36635 17.5629C9.62254 12.3973 12.1155 8.79545 12.1155 5.77858C12.1155 2.76098 9.38395 0.31543 6.36635 0.31543ZM6.36635 8.22054C5.17556 8.22054 4.21042 7.25539 4.21042 6.0646C4.21042 4.8738 5.17556 3.90866 6.36635 3.90866C7.55715 3.90866 8.52229 4.8738 8.52229 6.0646C8.52229 7.25539 7.55715 8.22054 6.36635 8.22054Z"
      fill="white"
    />
  </svg>
);

const DateIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5833 2.75V0.916667C15.5833 0.410667 15.9931 0 16.5 0C17.0069 0 17.4167 0.410667 17.4167 0.916667V2.75C17.4167 3.256 17.0069 3.66667 16.5 3.66667C15.9931 3.66667 15.5833 3.256 15.5833 2.75ZM4.58333 3.66667C5.09025 3.66667 5.5 3.256 5.5 2.75V0.916667C5.5 0.410667 5.09025 0 4.58333 0C4.07642 0 3.66667 0.410667 3.66667 0.916667V2.75C3.66667 3.256 4.07642 3.66667 4.58333 3.66667ZM16.5 15.5833V12.8333H15.5833V16.5H18.3333V15.5833H16.5ZM11.9167 16.0417C11.9167 18.3159 13.7674 20.1667 16.0417 20.1667C18.3159 20.1667 20.1667 18.3159 20.1667 16.0417C20.1667 13.7674 18.3159 11.9167 16.0417 11.9167C13.7674 11.9167 11.9167 13.7674 11.9167 16.0417ZM22 16.0417C22 19.3325 19.3325 22 16.0417 22C12.7508 22 10.0833 19.3325 10.0833 16.0417C10.0833 12.7508 12.7508 10.0833 16.0417 10.0833C19.3325 10.0833 22 12.7508 22 16.0417ZM8.94942 19.25H1.83333V7.33333H19.25V8.94942C19.9164 9.25192 20.5324 9.64333 21.0833 10.1118V1.83333H18.3333V2.75C18.3333 3.95633 17.1618 4.89408 15.8968 4.48617C15.1351 4.2405 14.6667 3.46775 14.6667 2.6675V1.83333H6.41667V2.75C6.41667 3.95633 5.24517 4.89408 3.98017 4.48617C3.21842 4.2405 2.75 3.46775 2.75 2.6675V1.83333H0V21.0833H10.1118C9.64333 20.5324 9.25192 19.9164 8.94942 19.25Z"
      fill="white"
    />
  </svg>
);

const PriceIcon = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10.2888" cy="10.4949" r="9.51149" fill="white" />
    <path
      d="M6.1167 13.0029V7.92532H7.38883C7.90253 7.92532 8.30961 8.05253 8.61007 8.30695C8.91296 8.56138 9.06441 8.90546 9.06441 9.3392C9.06441 9.63482 8.9905 9.89045 8.84269 10.1061C8.69488 10.3218 8.48286 10.4829 8.20663 10.5895C8.36898 10.6961 8.52769 10.8415 8.68277 11.0257C8.83785 11.2098 9.05593 11.5309 9.33701 11.9889C9.51389 12.2772 9.65564 12.4941 9.76226 12.6395L10.0312 13.0029H9.16618L8.94446 12.6685C8.93719 12.6564 8.92266 12.6358 8.90085 12.6068L8.7591 12.4068L8.53375 12.0361L8.29023 11.6399C8.13999 11.4315 8.00188 11.2656 7.87587 11.142C7.7523 11.0184 7.63962 10.93 7.53785 10.8767C7.4385 10.8209 7.2701 10.7931 7.03263 10.7931H6.84363V13.0029H6.1167ZM7.06171 8.54321H6.84363V10.1461H7.11987C7.48818 10.1461 7.74018 10.1146 7.87587 10.0516C8.01399 9.98859 8.12061 9.89409 8.19572 9.76809C8.27326 9.63966 8.31203 9.49428 8.31203 9.33193C8.31203 9.172 8.26963 9.02783 8.18482 8.8994C8.10001 8.76856 7.98007 8.67648 7.82499 8.62317C7.67233 8.56986 7.41791 8.54321 7.06171 8.54321ZM10.4601 14.7076V9.65905H11.6196C12.2132 9.65905 12.6748 9.80686 13.0044 10.1025C13.3363 10.3981 13.5023 10.8112 13.5023 11.3419C13.5023 11.8435 13.346 12.2554 13.0335 12.5777C12.7233 12.8999 12.3271 13.0611 11.8449 13.0611C11.6317 13.0611 11.3954 13.0138 11.1362 12.9193V14.7076H10.4601ZM11.605 10.2769H11.1362V12.3342C11.3397 12.4383 11.5529 12.4904 11.7759 12.4904C12.086 12.4904 12.3392 12.3826 12.5355 12.167C12.7342 11.9513 12.8335 11.6739 12.8335 11.3346C12.8335 11.1165 12.7863 10.9239 12.6918 10.7567C12.5997 10.5895 12.4725 10.4684 12.3102 10.3932C12.1502 10.3157 11.9152 10.2769 11.605 10.2769Z"
      fill="#373737"
    />
  </svg>
);
